import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DateRange from '@material-ui/icons/DateRange';
import EventNote from '@material-ui/icons/EventNote';
import { useTranslation } from 'react-i18next';

import ChainMetaIcon from './chain-meta-icon.tsx';

const useStyles = makeStyles((theme) => ({
    countsRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16,
        marginTop: 8,
    },
    countItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: theme.palette.common.darkGrey,
    },
}));

interface Props {
    stepCount: number;
    appointmentCount: number;
}

const ChainCounts = ({ stepCount, appointmentCount }: Props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.countsRow}>
            <span className={classes.countItem}>
                <ChainMetaIcon icon={EventNote} />
                <Typography variant="body1" component="span">
                    {t('ChainSuggestionsStepsCount', { count: stepCount })}
                </Typography>
            </span>
            <Typography variant="body1" component="span" aria-hidden="true">
                ·
            </Typography>
            <span className={classes.countItem}>
                <ChainMetaIcon icon={DateRange} />
                <Typography variant="body1" component="span">
                    {t('ChainSuggestionsAppointmentsCount', { count: appointmentCount })}
                </Typography>
            </span>
        </div>
    );
};

export default ChainCounts;
